import { useSelector, useDispatch } from 'react-redux';
import { LogOutAction, modalOpen } from './redux/layoutActions';
import { Modal, Button } from '../component';
import { flushUserCredentials } from '../helpers/manageStorage';

const LogOut = () => {
  const dispatch = useDispatch();
  const { statusModal } = useSelector((state: any) => state.layoutState);
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);

  const onLogOutButtonClick = () => {
    flushUserCredentials();
    dispatch(LogOutAction());
  };

  return (
    <Modal
      title={
        <span data-cy="LogoutTitle" className="text-primary">
          {nls.logoutTitle}
        </span>
      }
      size="small"
      open={statusModal === 'sair' ? true : false}
      close={() => dispatch(modalOpen(''))}
      closeText="Fechar"
      cy="LogOut"
      actions={
        <Button cy="Logout" color="primary" onClick={onLogOutButtonClick}>
          {nls.sair}
        </Button>
      }
    >
      {nls.logoutContent}
    </Modal>
  );
};

export default LogOut;
